export default {
    name: 'HealthDataContainer'
}